module.exports = __webpack_public_path__ + "static/media/MVNZ_web_6_preview.467b8774.jpg";